module.exports = __webpack_public_path__ + "img/Pic_WGM_LB_b.7140b5cb.gif";